import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import React from 'react';

const SearchStructuredData = ({ url }) => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'http://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              item: {
                '@id': url,
                name: 'Search',
              },
            },
          ],
        })}
      </script>
    </Helmet>
  );
};

SearchStructuredData.propTypes = {
  url: PropTypes.string.isRequired,
};

export default SearchStructuredData;
